import { LazyLoadComponent } from '@src/components';
import { lazy } from 'react';

const FaqPage = lazy(() =>
  import('@src/pages/Dashboard').then((module) => ({
    default: module.Faq,
  }))
);

export function FaqContainer() {
  return <LazyLoadComponent Component={<FaqPage />} />;
}
